export default class UpkError extends Error{
    public readonly code: string | undefined;
    constructor(message: string, code?: string){
        super(message);
        this.code = code;
    }
}